import React from 'react';
import dayjs from 'dayjs';

const DateRangeLabel = () => {
  const now = dayjs();
  const startOfMonth = now.startOf('month').format('MMM DD'); // e.g., Jul 01
  const endOfMonth = now.endOf('month').format('MMM DD');     // e.g., Jul 31

  return (
    <p className="float-start">
      <i className="mdi mdi-calendar me-1 text-primary"></i>
      {startOfMonth} - {endOfMonth}
    </p>
  );
};

export default DateRangeLabel;